import angular from 'angular';

import config from '../../config';
import _cdnResizeUrl from '../../components/services/cdnResizeUrl';
import _isCdnResizeEnabled from '../../components/services/isCdnResizeEnabled';

export default function Tasks(
  Users,
  Comments,
  Restangular,
  PersonaCollection,
  TaskCollection,
  dateFilter
) {
  'ngInject';

  function _sortBy(property) {
    return (_a, _b) => {
      const a = _a[property] || '';
      const b = _b[property] || '';
      a.localeCompare(b);
    };
  }

  function _setTaskDefaultGroups(task) {
    if (task.positions.length === 1) {
      task.position = task.positions[0];
    }

    if (task.locations.length === 1) {
      task.location = task.locations[0];
    }

    if (task.groups.length === 1) {
      task.group = task.groups[0];
    }
  }

  Restangular.extendModel('tasks', (task) => {
    if (task.length) {
      // When we create a new task we get an array of tasks back instead of a single element
      Restangular.restangularizeCollection(null, task, 'tasks');
      return task;
    }

    task.commentsCanBeLiked = false;

    if (task.completedDate) {
      task.completedDate = new Date(task.completedDate);
      task.completedMoreThenWeekAgo = (new Date() - task.completedDate) / 1000 > 60 * 60 * 24 * 7;
    }

    if (task.dueDate) {
      task.dueDate = new Date(task.dueDate);
    }

    if (!task.commentlist) {
      task.commentlist = [];
    }

    if (!task.personas) {
      task.personas = [];
    }

    Restangular.restangularizeCollection(null, task.commentlist, 'comments');
    Restangular.restangularizeCollection(null, task.personas, 'personas');

    task.users = PersonaCollection.unwrapUsers(task.personas).sort(_sortBy('fullname'));
    task.positions = task.personas.filter((p) => p.type === 'position').sort(_sortBy('name'));
    task.locations = task.personas.filter((p) => p.type === 'location').sort(_sortBy('name'));
    task.groups = task.personas.filter((p) => p.type === 'group').sort(_sortBy('name'));

    if (task.personas.length === 1 && task.personas[0].type === 'user') {
      task.assignee = task.personas[0];
    }

    _setTaskDefaultGroups(task);

    if (task.creator) {
      Restangular.restangularizeElement(null, task.creator, 'users');
    }

    task.firstImageAttachment = false;

    if (task.attachments?.length) {
      task.attachments.forEach((attachment) => {
        if (!attachment.url) {
          return;
        }

        let parts = attachment.url.split('/');
        attachment.fileName = decodeURIComponent(parts[parts.length - 1]);

        parts = attachment.fileName.split('.');
        attachment.ext = parts[parts.length - 1];

        if (attachment.mimetype === 'image/gif') {
          attachment.thumb = attachment.url;
          attachment.large = attachment.url;
        } else if (attachment.mimetype?.indexOf('image/') === 0) {
          if (_isCdnResizeEnabled()) {
            attachment.thumb = _cdnResizeUrl(attachment.url, 85, 50, 'cover');
            attachment.large = _cdnResizeUrl(attachment.url, 1000, 1000, 'inside');
            attachment.listThumb = _cdnResizeUrl(attachment.url, 280, 100, 'cover');
          } else {
            attachment.thumb = `${config.CLOUDINARY_BASE_URL}image/fetch/f_jpg,c_fill,h_50,w_85,b_rgb:f0f0f0/${encodeURIComponent(attachment.url)}`;
            attachment.large = `${config.CLOUDINARY_BASE_URL}image/fetch/f_jpg,c_limit,h_1000,w_1000/${encodeURIComponent(attachment.url)}`;
            attachment.listThumb = `${config.CLOUDINARY_BASE_URL}image/fetch/f_jpg,c_fill,h_100,w_280/${encodeURIComponent(attachment.url)}`;
          }
        }

        if (!task.firstImageAttachment && attachment.mimetype?.indexOf('image/') === 0) {
          task.firstImageAttachment = attachment;
        }
      });
    }

    task.searchValue = `${task.title} ${task.summary} ${task.personas
      .map((p) => (p.type === 'user' ? p.fullname : p.displayName))
      .join(' ')}`;

    task.complete = function completeTask() {
      const copy = Restangular.copy(task);
      copy.completed = true;
      copy.completedDate = new Date();

      return copy.put().then(() => {
        angular.extend(task, copy);
        return task;
      });
    };

    task.incomplete = function incompleteTask() {
      const copy = Restangular.copy(task);
      copy.completed = false;
      copy.completedDate = null;

      return copy.put().then(() => {
        angular.extend(task, copy);
        return task;
      });
    };

    task.cancelTask = function cancelTask() {
      return task.remove().then(() => {
        task.deleted = true;
        return task;
      });
    };

    task.addComment = function addComment(comment) {
      task.inprogress = true;
      return task
        .all('comments')
        .post(comment)
        .then(() => {
          task.inprogress = false;
          angular.copy({}, comment);
          return true;
        });
    };

    return task;
  });

  Restangular.addRequestInterceptor((element, operation, what) => {
    if (what === 'tasks') {
      // Do NOT send a payload for the DELETE, see https://github.com/getsling/sling-server/issues/1369
      if (operation === 'remove') {
        return null;
      }

      if (operation === 'post' || operation === 'put') {
        if (element.dueDate) {
          element.dueDate = dateFilter(element.dueDate, 'yyyy-MM-ddTHH:mm:ss');
        }
      }
    }

    return element;
  });

  Restangular.addResponseInterceptor((data, operation, what) => {
    if (what === 'tasks') {
      if (operation === 'post') {
        data.forEach((task) => {
          TaskCollection.addOrEditTask(task);
        });
      }

      if (operation === 'put') {
        TaskCollection.addOrEditTask(data);
      }

      if (operation === 'remove') {
        TaskCollection.deleteTask(data);
      }
    }

    return data;
  });

  return Restangular.service('tasks');
}
